export const toProductOptions = (productList = []) =>
  productList?.map(p => ({
    value: p.id,
    label: p.nameCode ?? p.name,
  })) ?? [];

export const findSelectedOption = (options = [], value) =>
  options.find(opt => opt.value === value) ?? null;
